import { useEffect, useRef, useState } from "react";

const Quotes = () => {
  const text =
    "My heart is yours to hold and cherish for the rest of our days.";
  const [displayed, setDisplayed] = useState("");
  const [typing, setTyping] = useState(true);
  const [inView, setInView] = useState(false);
  const containerRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !inView) {
          setInView(true);
        }
      },
      {
        threshold: 0.3,
        rootMargin: "0px 0px -50px 0px",
      }
    );

    const currentRef = containerRef.current;
    if (currentRef) {
      observer.observe(currentRef);
    }

    return () => {
      if (currentRef) {
        observer.unobserve(currentRef);
      }
    };
  }, [inView]);

  useEffect(() => {
    if (!inView) return;

    setDisplayed("");
    setTyping(true);
    let i = 0;
    const interval = setInterval(() => {
      setDisplayed((prev) => prev + text[i]);
      i++;
      if (i >= text.length) {
        clearInterval(interval);
        setTyping(false);
      }
    }, 30);
    return () => clearInterval(interval);
  }, [inView]);

  return (
    <div className="bg-white min-h-[50vh] lg:min-h-[40vh] flex flex-col justify-center items-center py-[4rem] lg:py-0">
      <div
        ref={containerRef}
        className="flex justify-center h-3 w-[75%] relative px-8 overflow-hidden mb-3"
        style={{
          backgroundImage: `url('/images/Frame.svg')`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      ></div>
      <div
        ref={containerRef}
        className="flex justify-center h-3 w-[75%] relative px-8 overflow-hidden mb-10"
        style={{
          backgroundImage: `url('/images/Frame.svg')`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      ></div>

      <div className="flex flex-col w-[88%] my-4 lg:my-10">
        <h3 className="font-gill font-light uppercase text-2xl lg:text-[40px] tracking-wider leading-[120%] text-center text-black">
          {displayed}
          {typing && <span className="animate-pulse">|</span>}
        </h3>
      </div>

      <div
        ref={containerRef}
        className="flex justify-center h-3 w-[75%] relative px-8 overflow-hidden mt-10"
        style={{
          backgroundImage: `url('/images/Frame.svg')`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      ></div>
      <div
        ref={containerRef}
        className="flex justify-center h-3 w-[75%] relative px-8 overflow-hidden mt-3"
        style={{
          backgroundImage: `url('/images/Frame.svg')`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      ></div>
    </div>
  );
};

export default Quotes;
